import { useNavigate } from 'react-router-dom'
import { useI18n } from '../../../i18n'
import { getStandardDisplayName, normalizeComplianceStandardCode } from '../../../utils/complianceStandard'
import type { UnifiedWorkflowStage } from '../../../types/unifiedExecutiveContext'
import styles from '../../../styles/enterprise/EnterpriseOperationalUx.module.scss'

type Props = {
  workflows: UnifiedWorkflowStage[]
  compact?: boolean
}

export default function OperationalWorkflowStatePanel({ workflows, compact = false }: Props) {
  const { t } = useI18n()
  const navigate = useNavigate()

  if (!workflows.length) {
    return (
      <p className={styles.emptyState}>
        {t('enterpriseOperationalUx.context.noWorkflowDegradation', 'No workflow degradation')}
      </p>
    )
  }

  return (
    <div>
      <p className={styles.postureMetricLabel}>
        {t('enterpriseOperationalUx.context.workflowDegradation', 'Workflow degradation')}
      </p>
      <div className={compact ? styles.chipRow : styles.workflowRow}>
        {workflows.map((w) => (
          <button
            key={`${w.standardCode}-${w.workflowStage}`}
            type="button"
            className={styles.badgeWarn}
            style={{ cursor: 'pointer', border: 'none' }}
            onClick={() =>
              navigate(
                `/compliance-workflow/${encodeURIComponent(normalizeComplianceStandardCode(w.standardCode))}`,
              )
            }
          >
            {getStandardDisplayName(t, w.standardCode)}: {w.workflowStage}
          </button>
        ))}
      </div>
    </div>
  )
}
